<div class="modal inmodal fade in show">
    <form #form="ngForm" submittable autocomplete="off">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="close()">
                        <span>×</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-sm-8">Edit Resident Name</h4>
                </div>

                <div class="modal-body detailed-view-body">
                    <div class="row m-b-md">
                        <div class="dv-label col-md-3">
                            <label>Full Name</label>
                        </div>
                        <div class="col-md-9">
                            <input class="form-control" name="fullName" [(ngModel)]="itemData.fullName" required>
                        </div>
                    </div>

                    <div class="row text-center">
                        <button class="btn btn-primary submit-btn"
                                type="submit"
                                (click)="onSubmit(form)"
                                [disabled]="disabledSubmit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="modal-backdrop fade in" (click)="close()"></div>
</div>




// WEBPACK FOOTER //
// /app/src/app/views/admin/user/edit-name-modal/edit-name-modal.component.html